import { render, staticRenderFns } from "./isNeedSmtDialog.vue?vue&type=template&id=0cf8665f"
import script from "./isNeedSmtDialog.vue?vue&type=script&lang=js"
export * from "./isNeedSmtDialog.vue?vue&type=script&lang=js"
import style0 from "./isNeedSmtDialog.vue?vue&type=style&index=0&id=0cf8665f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports